// extracted by mini-css-extract-plugin
module.exports = {"CocktailInput":"CocktailInput_CocktailInput__2AApT"};